import { Product } from '@shared/types/models'

export default (product: Product): string => {
    if (product.hasOwnProperty(`title_${Locale}`)) {
        return product[`title_${Locale}`]
    }

    return product.title
}
